import { ReactNode, useEffect, useState } from "react";
import { useDebounce } from "react-use";

const withSearchDrawer = (Component: React.ComponentType<any>) => {
  return ({
    children,
    isOpenned,
    data,
    isLoadedData,
    isLoadingData,
    cachedKey,
    placeholder,
    isEmpty,
    hasAllFetched,
    loadMoreRef,
    close,
    onSearch,
    ...props
  }: {
    children?: ReactNode;
    isOpenned: boolean;
    data: any[];
    isLoadedData: boolean;
    isLoadingData: boolean;
    cachedKey: string;
    placeholder: string;
    isEmpty: boolean;
    hasAllFetched: boolean;
    loadMoreRef: (node?: Element | null) => void;
    close: () => void;
    onSearch: (search: string | null) => void;
  }) => {
    const cachedSearchFilter = localStorage.getItem(cachedKey) || null;
    const [search, setSearch] = useState(cachedSearchFilter);
    const [debouncedSearch, setDebouncedSearch] = useState(cachedSearchFilter);

    useDebounce(
      () => {
        if (!search) {
          localStorage.removeItem(cachedKey);
        } else {
          localStorage.setItem(cachedKey, search);
        }
        setDebouncedSearch(search);
        onSearch(search);
      },
      1000,
      [search],
    );

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      if (isLoadedData) {
        setIsLoading(false);
      }
    }, [isLoadedData]);

    const handleClose = () => {
      setSearch(null);
      close();
    };

    const handleSearch = (search: string | null) => {
      setSearch(search);
      onSearch(search);
    };

    return (
      <Component
        handleClose={handleClose}
        handleSearch={handleSearch}
        debouncedSearch={debouncedSearch}
        data={data}
        isLoadingData={isLoadingData}
        isLoadedData={isLoadedData}
        isLoading={isLoading}
        isOpenned={isOpenned}
        isEmpty={isEmpty}
        hasAllFetched={hasAllFetched}
        loadMoreRef={loadMoreRef}
        children={children}
        placeholder={placeholder}
        {...props}
      />
    );
  };
};

export default withSearchDrawer;
